export default __webpack_public_path__ + "static/media/5483.972fba5e.png";